import { render, staticRenderFns } from "./VideoLengthIcon.vue?vue&type=template&id=b282e88c&scoped=true"
import script from "./VideoLengthIcon.vue?vue&type=script&lang=js"
export * from "./VideoLengthIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b282e88c",
  null
  
)

export default component.exports